import React from 'react';
import PropTypes from 'prop-types';
import Card from 'components/common/Card';
import DoughnutChart from 'components/common/DoughnutChart';
import ChartLabel from 'components/common/ChartLabel';

const OSChartCard = ({ operatingSystems = [] }) => {

  const chartBackgroundColor = [
    '#7c98ab',
    '#9c9359',
    '#dbbc8e',
    '#ae8a8c',
    '#8c7386',
    '#d08d8b',
    '#766161',
    '#a9c8c0',
    '#a3cb8f',
  ];

  const getCustomLabels = () => (
    operatingSystems.map(({ name }, index) => (
      <div
        className="column is-half-widescreen is-full-touch is-flex is-align-items-center my-1"
        key={name}
      >
        <ChartLabel
          label={name}
          color={chartBackgroundColor[index]}
        />
      </div>
    ))
  );

  return (
    <Card>
      <h3 className="has-text-weight-bold has-text-light mb-2">
        Operating Systems
      </h3>
      <div className="columns is-multiline">
        <div
          style={{ width: '100%', minHeight: 192 }}
          className="columns column is-12 is-variable is-1 is-multiline"
        >
          {getCustomLabels()}
        </div>
        <div className="column is-12">
          <DoughnutChart
            id="os-chart"
            data={operatingSystems.map(os => os.count)}
            labels={operatingSystems.map(os => os.name)}
            backgroundColor={chartBackgroundColor}
            circumference={180}
            rotation={270}
            height={150}
          />
        </div>
      </div>
    </Card>
  );
};

OSChartCard.propTypes = {
  operatingSystems: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      count: PropTypes.any,
    })
  )
};

export default OSChartCard;
